import Image from 'next/image';
import SkillzLogoHorizontal from '@/../public/Skillz_Logo_Horizontal_1Color_White.png';
import Trophy from '@/../public/trophy.png';

const LiveEventBanner = () => {
  return (
    <div className={'w-screen grow relative min-h-[220px]'}>
      <div className={'flex justify-center mt-8'}>
        <Image src={SkillzLogoHorizontal} alt={'Skillz'} width={180} />
      </div>
      <div className={'flex justify-center'}>
        <Image src={Trophy} alt={'Win games'} height={220} />
      </div>
    </div>
  );
};

export default LiveEventBanner;
